import { Dialog } from "@headlessui/react"
import { useState, useEffect } from "react"
import { useSelector } from "react-redux"
import { useLocation } from 'react-router-dom'
import { IKImage } from 'imagekitio-react'
import { useDispatch } from "react-redux"
import { editOneDayChallenge } from "../../redux/actions/userActivity"

export function ExtendChallenge() {

    const location = useLocation()
    const user_extended_challenges = useSelector(store => store?.userActivity?.user_extended_challenges)
    const [extendChallengeModal, setExtendChallengeModal] = useState({ show: false, data: null })
    const dispatch = useDispatch()

    useEffect(() => {
        if (user_extended_challenges) {
            let sorted_challenges = user_extended_challenges?.sort((a, b) => a?.expires_at - b?.expires_at)
            let today_date = Date.now()

            if (sorted_challenges[0]?.expires_at < today_date) {
                setExtendChallengeModal(prev => ({ ...prev, show: true, data: sorted_challenges[0] }))
            }
        }

    }, [location.pathname])

    function onCloseModal(type) {
        dispatch(editOneDayChallenge(extendChallengeModal.data, type))
        setExtendChallengeModal(prev => ({ ...prev, show: false, data: null }))
    }


    return (
        <div>
            <Dialog open={extendChallengeModal.show} onClose={() => onCloseModal(false)}
                as="div"
                style={{ zIndex: '9999999999' }}
                className="fixed inset-0 z-10 overflow-y-auto flex md:justify-start md:mt-20 -mt-10 justify-center flex-col items-center">
                <Dialog.Overlay className="fixed inset-0 bg-black opacity-70 z-10" />
                <Dialog.Title />
                <Dialog.Description />
                <div className='bg-white z-10 md:w-2/3 lg:w-2/4 md:h-4/5 w-5/6 h-[30rem] rounded flex flex-col justify-between py-4 px-4 items-center md:p-4 text-center shadow-2xl'>
                    <div className="flex flex-col w-full h-full justify-between items-center p-2 py-4">
                        <h2 className="font-bold text-base md:text-2xl">Oh No! Your Challenge Has Expired!</h2>
                        <img
                            urlEndpoint="https://assets.learntube.ai/files/"
                            src='https://assets.learntube.ai/files/Content_player/challengeExpired.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1661768053673'
                            className="w-full h-36 md:w-full md:h-48"
                            transformation={[{
                                "height": "160",
                                "width": "160",
                            }]}
                        />
                        <p className="md:text-lg text-sm">Your one-day challenge has been expired for <span className="text-[#FDBF48] font-semibold">{extendChallengeModal?.data?.['mSkill-name']}</span> in <span className="text-[#FDBF48] font-semibold">{extendChallengeModal?.data?.['course-name']}</span>. But don't worry, you can request for Extension!</p>
                        <div className="flex w-2/3 justify-between items-center md:flex-row flex-col">
                            <button className="bg-[#FDBF48] text-white font-bold px-4 py-2 rounded-lg border-2 border-[#FDBF48] w-full md:w-auto mb-3 md:mb-0 text-sm md:text-base" onClick={() => onCloseModal(true)}>Request Extension</button>
                            <button className=" text-[#FDBF48] font-bold px-4 py-2 rounded-lg border-2 border-[#FDBF48] w-full md:w-auto text-sm md:text-base" onClick={() => onCloseModal(false)}>Mark as Failed</button>
                        </div>
                    </div>
                </div>
            </Dialog>
        </div>
    )
}